const noop = (() => {
});
export {
  noop
};
/*                                                        */
